import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';

const DAY_MILLISECONDS = 24 * 60 * 60 * 1000;
const DEFAULT_HISTORY_DAYS = 365;

export const historyDateToDayNumber = (date) =>
  Math.floor(Date.parse(`${date}T00:00:00Z`) / DAY_MILLISECONDS);

export const historyDayNumberToDate = (value) =>
  new Date(value * DAY_MILLISECONDS).toISOString().slice(0, 10);

const HeatmapDateSlider = ({ date, onChange, today }) => {
  const selectedDay = historyDateToDayNumber(date);
  const todayDay = historyDateToDayNumber(today);
  const minimumDay = Math.min(selectedDay, todayDay - DEFAULT_HISTORY_DAYS);
  const [pendingDay, setPendingDay] = useState(selectedDay);

  useEffect(() => {
    setPendingDay(selectedDay);
  }, [selectedDay]);

  const handleKeyDown = (event) => {
    const change = {
      ArrowDown: -1,
      ArrowLeft: -1,
      ArrowRight: 1,
      ArrowUp: 1
    }[event.key];
    if (!change) return;
    event.preventDefault();
    const nextDay = Math.max(
      minimumDay,
      Math.min(todayDay, pendingDay + change)
    );
    setPendingDay(nextDay);
    onChange(historyDayNumberToDate(nextDay));
  };

  return (
    <Box
      aria-label="Heatmap history controls"
      component="section"
      sx={{
        bgcolor: 'rgba(255, 255, 255, 0.96)',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
        px: 2.5,
        py: 1.5
      }}
    >
      <Box
        sx={{
          alignItems: 'baseline',
          display: 'flex',
          gap: 2,
          justifyContent: 'space-between',
          mb: 0.5
        }}
      >
        <Typography color="text.secondary" variant="body2">
          Historical date
        </Typography>
        <Typography fontWeight={600} variant="body2">
          {historyDayNumberToDate(pendingDay)}
        </Typography>
      </Box>
      <Slider
        aria-label="Heatmap history date"
        getAriaValueText={historyDayNumberToDate}
        max={todayDay}
        min={minimumDay}
        onChange={(_event, value) => setPendingDay(value)}
        onChangeCommitted={(_event, value) =>
          onChange(historyDayNumberToDate(value))
        }
        onKeyDown={handleKeyDown}
        step={1}
        sx={{
          display: 'block',
          mb: 0,
          mt: 0.25,
          py: 1
        }}
        value={pendingDay}
        valueLabelDisplay="auto"
        valueLabelFormat={historyDayNumberToDate}
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography color="text.secondary" variant="caption">
          {historyDayNumberToDate(minimumDay)}
        </Typography>
        <Typography color="text.secondary" variant="caption">
          Today
        </Typography>
      </Box>
    </Box>
  );
};

export default HeatmapDateSlider;
